// extracted by mini-css-extract-plugin
export default {"banner":"fT","banner_wrapper":"gT","text":"hT","new_at":"iT","rounded_arrow":"jT","image":"kT","video":"lT"};
    if(module.hot) {
      // 1713809679205
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  